import React from 'react';
import { Grid, Typography, CircularProgress, withStyles } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { withTranslation } from 'react-i18next';
import highchartsXrange from 'highcharts/modules/xrange';
import highchartsTimeline from 'highcharts/modules/timeline';
import Buttonbar from '../Navbar/Buttonbar';
import highchartsMore from 'highcharts/highcharts-more';
import CustomChartFooter from '../customChartFooter';

highchartsXrange(Highcharts);
highchartsTimeline(Highcharts);
highchartsMore(Highcharts);

class VitalsignDetails extends React.PureComponent {
  getChartHRVsTemp(dataHeartrate, dataTemperature) {
    const { t } = this.props;
    const chartHRVsTemp = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'HRVsTemp');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        // text: `${t("temperature_and_heartrate")}`,
        text: ' ',
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          title: {
            text: `${t('temperature')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} °C',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // floor: 33,
          // ceiling: 45,
        },
        {
          // Secondary yAxis
          title: {
            text: `${t('heart_rate')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} bpm',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // floor: 50,
          // ceiling: 150,
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
        headerFormat:
          '<span style="color:{point.color}"></span> <span style="font-size: 10px"> {point.x:%d/%m/%Y %H:%M:%S}</span><br/>',
      },
      plotOptions: {
        series: {
          // opacity: 0.7,
          lineWidth: 2,
        },
      },
      series: [
        {
          name: `${t('temperature')}`,
          type: 'areaspline',
          // yAxis: 1,
          data: dataTemperature.data,
          color: '#10b0c3',
          dataLabels: {
            enabled: true,
            rotation: 0,
            color: '#FFFFFF',
            borderColor: '#FFFFFF',
            borderWidth: 1,
            backgroundColor: '#10b0c3',
            align: 'center',
            format: '{point.y:.1f}', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '12px',
              fontFamily: 'kanit',
              fontWeight: 'bold',
              textOutline: 0,
            },
          },
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(16,176,195,0.8)'],
              [1, 'rgba(244,244,244,0.6)'],
            ],
          },
          // opacity: 0.9,
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> °C</span><br/>',
          },
        },
        {
          name: `${t('heart_rate')}`,
          type: 'areaspline',
          yAxis: 1,
          data: dataHeartrate.data,
          color: '#EB5861',
          dataLabels: {
            enabled: true,
            rotation: 0,
            color: '#FFFFFF',
            borderColor: '#FFFFFF',
            borderWidth: 1,
            backgroundColor: '#EB5861',
            align: 'center',
            // format: "{point.y:.1f}", // one decimal
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '12px',
              fontFamily: 'kanit',
              fontWeight: 'bold',
              textOutline: 0,
            },
          },
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(235,88,97,0.9)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          // fillOpacity: 0.2,
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> bpm</span><br/>',
          },
        },
      ],
    };

    const { classes } = this.props;
    if (dataHeartrate.data.length > 0 || dataTemperature.data.length > 0) {
      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact highcharts={Highcharts} options={chartHRVsTemp} callback={this.props.dataChartHRVsTemp} />
        </Typography>
      );
    }
  }

  getChartMedianHRVsTemp(viewType, dataHeartrate, dataTemperature) {
    const { t } = this.props;
    const chartHRVsTemp = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'HRVsTemp');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: ' ', //`${t("temperature_and_heartrate")}`,
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          title: {
            text: `${t('temperature')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} °C',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // floor: 33,
          // ceiling: 45,
        },
        {
          // Secondary yAxis
          title: {
            text: `${t('heart_rate')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} bpm',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // floor: 50,
          // ceiling: 150,
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
        headerFormat: `<span style="color:{point.color}"></span> <span style="font-size: 10px">${viewType === 'year' ? '{point.x:%m/%Y}' : '{point.x:%d/%m/%Y}'}</span><br/>`,
      },
      plotOptions: {
        series: {
          // opacity: 0.7,
          lineWidth: 1,
        },
      },
      series: [
        {
          name: `${t('temperature')}`,
          type: 'areaspline',
          data: dataTemperature.data,
          color: '#10b0c3',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(16,176,195,0.9)'],
              [1, 'rgba(244,244,244,0.6)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> °C</span> ' +
              ' ',
          },
          marker: {
            symbol: 'circle',
          },
        },
        {
          name: `${t('temperature')} range`,
          type: 'errorbar',
          data: dataTemperature.minmax,
          tooltip: {
            pointFormat: `<span style="font-size: 12px;">(${t('min_value')}: {point.low} °C, ${t('max_value')}: {point.high} °C)</span><br/><br/>`,
          },
          whiskerLength: 8,
          stemWidth: 2,
          color: '#E7E7E7',
        },
        {
          name: `${t('heart_rate')}`,
          type: 'areaspline',
          yAxis: 1,
          data: dataHeartrate.data,
          color: '#EB5861',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(235,88,97,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<br/><br/><span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> bpm</span> ' +
              ' ',
          },
          marker: {
            symbol: 'circle',
          },
        },
        {
          name: `${t('heart_rate')} range`,
          type: 'errorbar',
          data: dataHeartrate.minmax,
          tooltip: {
            pointFormat: ` <span style="font-size: 12px;">(${t('min_value')}: {point.low} bpm, ${t('max_value')}: {point.high} bpm)</span><br/>`,
          },
          whiskerLength: 8,
          stemWidth: 2,
          color: '#E7E7E7',
        },
      ],
    };

    const { classes } = this.props;
    if (dataHeartrate.data.length > 0 || dataTemperature.data.length > 0) {
      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact highcharts={Highcharts} options={chartHRVsTemp} callback={this.props.dataChartHRVsTemp} />
        </Typography>
      );
    }
  }

  getChartSpo2(dataSpo2) {
    const { t } = this.props;
    const chartSpo2 = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'spo2');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '', //`${t("spo2")}`,
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          labels: {
            enabled: true,
            format: '{value} %',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          title: {
            text: `${t('spo2')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // floor: 70,
          // ceiling: 120,
        },
      ],
      tooltip: {
        shared: true,
        headerFormat:
          '<span style="color:{point.color}"></span> <span style="font-size: 10px"> {point.x:%d/%m/%Y %H:%M:%S}</span><br/>',
      },
      plotOptions: {
        series: {
          // opacity: 0.8,
          lineWidth: 2.5,
        },
      },
      series: [
        {
          name: `${t('spo2')}`,
          type: 'areaspline',
          data: dataSpo2.data,
          color: '#009D9A',
          dataLabels: {
            enabled: true,
            rotation: 0,
            color: '#FFFFFF',
            borderColor: '#FFFFFF',
            borderWidth: 1,
            backgroundColor: '#009D9A',
            align: 'center',
            // format: "{point.y:.1f}", // one decimal
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '12px',
              fontFamily: 'kanit',
              fontWeight: 'bold',
              textOutline: 0,
            },
          },
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(0,157,154,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> %</span><br/>',
          },
        },
      ],
    };

    const { classes } = this.props;
    if (dataSpo2.data && dataSpo2.data.length > 0) {
      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact highcharts={Highcharts} options={chartSpo2} callback={this.props.dataChartSpo2} />
        </Typography>
      );
    }
  }

  getChartMedianSpo2(viewType, dataSpo2) {
    const { t } = this.props;
    const chartSpo2 = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'spo2');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '', //`${t("spo2")}`,
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          labels: {
            enabled: true,
            format: '{value} %',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          title: {
            text: `${t('spo2')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // min: 70,
          // max: 120
        },
      ],
      tooltip: {
        shared: true,
        headerFormat: `<span style="color:{point.color}"></span> <span style="font-size: 10px">${viewType === 'year' ? '{point.x:%m/%Y}' : '{point.x:%d/%m/%Y}'}</span><br/>`,
      },
      plotOptions: {
        series: {
          lineWidth: 1,
        },
      },
      series: [
        {
          name: `${t('spo2')}`,
          type: 'areaspline',
          data: dataSpo2.data || [],
          color: '#009D9A',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(0,157,154,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> %</span> ' +
              ' ',
          },
          marker: {
            symbol: 'circle',
          },
        },
        {
          name: `${t('spo2')} range`,
          type: 'errorbar',
          data: dataSpo2.minmax || [],
          tooltip: {
            pointFormat: `<span style="font-size: 12px;">(${t('min_value')}: {point.low} %, ${t('max_value')}: {point.high} %)</span><br/>`,
          },
          whiskerLength: 8,
          stemWidth: 2,
          color: '#E7E7E7',
        },
      ],
    };

    const { classes } = this.props;
    if (dataSpo2.data && dataSpo2.data.length > 0) {
      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact highcharts={Highcharts} options={chartSpo2} callback={this.props.dataChartSpo2} />
        </Typography>
      );
    }
  }

  getChartRespirationRate(dataRespirationRate) {
    const { t } = this.props;
    const chartRespirationRate = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'respirationRate');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          labels: {
            enabled: true,
            format: '{value} bpm',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          title: {
            text: `${t('respiratory_rate')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // floor: 70,
          // ceiling: 120,
        },
      ],
      tooltip: {
        shared: true,
        headerFormat:
          '<span style="color:{point.color}"></span> <span style="font-size: 10px"> {point.x:%d/%m/%Y %H:%M:%S}</span><br/>',
      },
      plotOptions: {
        series: {
          // opacity: 0.8,
          lineWidth: 2.5,
        },
      },
      series: [
        {
          name: `${t('respiratory_rate')}`,
          type: 'areaspline',
          data: dataRespirationRate.data,
          color: '#FEB84F',
          dataLabels: {
            enabled: true,
            rotation: 0,
            color: '#FFFFFF',
            borderColor: '#FFFFFF',
            borderWidth: 1,
            backgroundColor: '#FEB84F',
            align: 'center',
            // format: "{point.y:.1f}", // one decimal
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '12px',
              fontFamily: 'kanit',
              fontWeight: 'bold',
              textOutline: 0,
            },
          },
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(254, 184, 79,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> bpm</span><br/>',
          },
        },
      ],
    };

    const { classes } = this.props;
    if (dataRespirationRate.data && dataRespirationRate.data.length > 0) {
      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartRespirationRate}
            callback={this.props.dataChartRespirationRate}
          />
        </Typography>
      );
    }
  }

  getChartMedianRespirationRate(viewType, dataRespirationRate) {
    const { t } = this.props;
    const chartRespirationRate = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'respirationRate');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          labels: {
            enabled: true,
            format: '{value} bpm',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          title: {
            text: `${t('respiratory_rate')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          // min: 70,
          // max: 120
        },
      ],
      tooltip: {
        shared: true,
        headerFormat: `<span style="color:{point.color}"></span> <span style="font-size: 10px">${viewType === 'year' ? '{point.x:%m/%Y}' : '{point.x:%d/%m/%Y}'}</span><br/>`,
      },
      plotOptions: {
        series: {
          lineWidth: 1,
        },
      },
      series: [
        {
          name: `${t('respiratory_rate')}`,
          type: 'areaspline',
          data: dataRespirationRate.data || [],
          color: '#FEB84F',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(254, 184, 79,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> bpm</span> ' +
              ' ',
          },
          marker: {
            symbol: 'circle',
          },
        },
        {
          name: `${t('respiratory_rate')} range`,
          type: 'errorbar',
          data: dataRespirationRate.minmax || [],
          tooltip: {
            pointFormat: `<span style="font-size: 12px;">(${t('min_value')}: {point.low} bpm, ${t('max_value')}: {point.high} bpm)</span><br/>`,
          },
          whiskerLength: 8,
          stemWidth: 2,
          color: '#E7E7E7',
        },
      ],
    };

    const { classes } = this.props;
    if (dataRespirationRate.data && dataRespirationRate.data.length > 0) {
      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartRespirationRate}
            callback={this.props.dataChartRespirationRate}
          />
        </Typography>
      );
    }
  }

  getChartBloodPressure(systolicData, diastolicData) {
    const { t } = this.props;
    const chartBloodPressure = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'bloodpressure');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '', //`${t("blood_pressure")}`,
      },
      xAxis: {
        type: 'datetime',
        // labels: {
        //   formatter: function() {
        //     return Highcharts.dateFormat("%d/%m", this.value);
        //   }
        // }
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          title: {
            text: `${t('systolic')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} mmHg',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          min: 0,
          max: 240,
        },
        {
          // Secondary yAxis
          title: {
            text: `${t('diastolic')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} mmHg',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          min: 0,
          max: 240,
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
        headerFormat:
          '<span style="color:{point.color}"></span> <span style="font-size: 10px"> {point.x:%d/%m/%Y %H:%M:%S}</span><br/>',
      },
      plotOptions: {
        series: {
          // opacity: 0.8,
          lineWidth: 2.5,
        },
      },
      series: [
        {
          name: `${t('systolic')}`,
          type: 'areaspline',
          data: systolicData,
          color: '#10b0c3',
          dataLabels: {
            enabled: true,
            rotation: 0,
            color: '#FFFFFF',
            borderColor: '#FFFFFF',
            borderWidth: 1,
            backgroundColor: '#10b0c3',
            align: 'center',
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '12px',
              fontFamily: 'kanit',
              fontWeight: 'bold',
              textOutline: 0,
            },
          },
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(16,176,195,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> mmHg</span><br/>',
          },
        },
        {
          name: `${t('diastolic')}`,
          type: 'areaspline',
          data: diastolicData,
          color: '#9CEFE5',
          yAxis: 1,
          dataLabels: {
            enabled: true,
            rotation: 0,
            color: '#4D4E4E',
            borderColor: '#FFFFFF',
            borderWidth: 1,
            backgroundColor: '#9CEFE5',
            align: 'center',
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '12px',
              fontFamily: 'kanit',
              fontWeight: 'bold',
              textOutline: 0,
            },
          },
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(156,239,229,0.9)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> mmHg</span><br/>',
          },
        },
      ],
    };

    if (systolicData.length > 0 || diastolicData.length > 0) {
      return (
        <Typography component='div' style={{ width: '100%', maxHeight: '500px', paddingBottom: 20 }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartBloodPressure}
            callback={this.props.dataChartBloodPressure}
          />
        </Typography>
      );
    }
  }

  getChartMedianBloodPressure(viewType, systolicData, diastolicData) {
    const { t } = this.props;
    const chartBloodPressure = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'bloodpressure');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '', //`${t("blood_pressure")}`,
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
      },
      yAxis: [
        {
          // Primary yAxis
          title: {
            text: `${t('systolic')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} mmHg',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          min: 0,
          max: 240,
        },
        {
          // Secondary yAxis
          title: {
            text: `${t('diastolic')}`,
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          labels: {
            enabled: true,
            format: '{value} mmHg',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          min: 0,
          max: 240,
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
        headerFormat: `<span style="color:{point.color}"></span> <span style="font-size: 10px">${viewType === 'year' ? '{point.x:%m/%Y}' : '{point.x:%d/%m/%Y}'}</span><br/>`,
      },
      plotOptions: {
        series: {
          lineWidth: 1,
        },
      },
      series: [
        {
          name: `${t('systolic')}`,
          type: 'areaspline',
          data: systolicData.data,
          color: '#10b0c3',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(16,176,195,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          tooltip: {
            pointFormat:
              '<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> mmHg</span> ' +
              ' ',
          },
          marker: {
            symbol: 'circle',
          },
        },
        {
          name: `${t('systolic')} range`,
          type: 'errorbar',
          data: systolicData.minmax,
          tooltip: {
            pointFormat: `<span style="font-size: 12px;">(${t('min_value')}: {point.low} mmHg, ${t('max_value')}: {point.high} mmHg)</span><br/>`,
          },
          whiskerLength: 8,
          stemWidth: 2,
          color: '#E7E7E7',
        },
        {
          name: `${t('diastolic')}`,
          type: 'areaspline',
          data: diastolicData.data,
          color: '#9CEFE5',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(156,239,229,0.8)'],
              [1, 'rgba(244,244,244,0.2)'],
            ],
          },
          yAxis: 1,
          tooltip: {
            pointFormat:
              '<br/><span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> mmHg</span> ' +
              ' ',
          },
          marker: {
            symbol: 'circle',
          },
        },
        {
          name: `${t('diastolic')} range`,
          type: 'errorbar',
          data: diastolicData.minmax,
          tooltip: {
            pointFormat: `<span style="font-size: 12px;">(${t('min_value')}: {point.low} mmHg, ${t('max_value')}: {point.high} mmHg)</span><br/>`,
          },
          whiskerLength: 8,
          stemWidth: 2,
          color: '#E7E7E7',
        },
      ],
    };

    if (systolicData.data.length > 0 || diastolicData.data.length > 0) {
      return (
        <Typography component='div' style={{ width: '100%', maxHeight: '500px', paddingBottom: 20 }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartBloodPressure}
            callback={this.props.dataChartBloodPressure}
          />
        </Typography>
      );
    }
  }

  render() {
    const { t, classes, viewType } = this.props;
    const { chartHeartrate, chartTemperature, chartSpo2, chartBloodPressure, loading } =
      this.props.vitalsign.toJS();

    return (
      <div className='flex-wrap flex-auto w-screen bg-gradient-to-b from-primary-gradient to-transparent'>
        <Grid container>
          <div className='flex-wrap w-full pt-3 mx-auto px-19 md:flex'>
            {this.props.zoom && (
              <div className='flex-wrap w-full pt-1 mx-auto pb-7 md:flex h-25 space-5'>
                <div className='relative items-end justify-end flex-grow text-right'>
                  <button
                    className='bottom-0 right-0 h-10 px-5 text-sm font-bold text-gray-600 border border-gray-300 rounded-lg bg-button-download '
                    onClick={this.props.resetZoom}
                  >
                    {t('reset_zoom')}
                  </button>
                </div>
              </div>
            )}
            {!loading ? (
              (chartHeartrate && chartHeartrate.data.length > 0) ||
              (chartTemperature && chartTemperature.data.length > 0) ||
              (chartSpo2 && chartSpo2.data.length > 0) ||
              // (chartRespirationRate && chartRespirationRate.data.length > 0) ||
              (chartBloodPressure && chartBloodPressure.systolic.length > 0) ||
              (chartBloodPressure && chartBloodPressure.diastolic.length > 0) ? (
                // <div className="w-full bg-white rounded md:box-content">
                <div className='relative flex-col flex-wrap w-full mb-5 bg-white rounded shadow-lg md:box-content'>
                  <div className='block col-span-12 px-1 pt-4 lg:flex md:flex xl:flex'>
                    <Buttonbar onChangePeriod={this.props.onChangePeriod} viewType={this.props.viewType} t={t} />
                  </div>
                  <div className='px-8 pb-5'>
                    {((chartHeartrate && chartHeartrate.data.length > 0) ||
                      (chartTemperature && chartTemperature.data.length > 0)) && (
                      <div className='p-3'>
                        <div className='text-lg font-semibold text-summary-header'>
                          {t('temperature_and_heartrate')}
                        </div>
                        {viewType === 'week'
                          ? this.getChartHRVsTemp(chartHeartrate, chartTemperature)
                          : this.getChartMedianHRVsTemp(viewType, chartHeartrate, chartTemperature)}
                      </div>
                    )}

                    {chartSpo2 && chartSpo2.data && chartSpo2.data.length > 0 && (
                      <div className='p-3'>
                        <div className='text-lg font-semibold text-summary-header'>{t('spo2')}</div>
                        {viewType === 'week'
                          ? this.getChartSpo2(chartSpo2)
                          : this.getChartMedianSpo2(viewType, chartSpo2)}
                      </div>
                    )}

                    {/* {(chartRespirationRate && chartRespirationRate.data && chartRespirationRate.data.length > 0) &&
                      <div className="p-3">
                        <div className="text-lg font-semibold text-summary-header">{t("respiratory_rate")}</div>
                        {viewType === 'week' ? this.getChartRespirationRate(chartRespirationRate) : this.getChartMedianRespirationRate(viewType, chartRespirationRate)}
                      </div>
                    } */}

                    {((chartBloodPressure && chartBloodPressure.systolic.length > 0) ||
                      (chartBloodPressure &&
                        chartBloodPressure.systolic &&
                        chartBloodPressure.systolic.data &&
                        chartBloodPressure.systolic.data.length > 0) ||
                      (chartBloodPressure && chartBloodPressure.diastolic.length > 0) ||
                      (chartBloodPressure &&
                        chartBloodPressure.diastolic &&
                        chartBloodPressure.diastolic.data &&
                        chartBloodPressure.diastolic.data.length > 0)) && (
                      <div className='p-3'>
                        <div className='text-lg font-semibold text-summary-header'>{t('blood_pressure')}</div>
                        {viewType === 'week'
                          ? this.getChartBloodPressure(
                              chartBloodPressure.systolic || [],
                              chartBloodPressure.diastolic || [],
                            )
                          : this.getChartMedianBloodPressure(
                              viewType,
                              chartBloodPressure.systolic || [],
                              chartBloodPressure.diastolic || [],
                            )}
                      </div>
                    )}
                  </div>
                  <div className='mb-2'>
                    <CustomChartFooter
                      endDate={this.props.endDate}
                      startDate={this.props.startDate}
                      viewType={this.props.viewType}
                      handleBackButtonClick={this.props.handleBackButtonClick}
                      handleNextButtonClick={this.props.handleNextButtonClick}
                    />
                  </div>
                </div>
              ) : (
                <div className='w-full max-h-screen bg-white rounded md:box-content'>
                  <Grid container>
                    <Typography component='div' className={classes.noDataBox}>
                      {' '}
                      {t('no_data')}
                    </Typography>
                  </Grid>
                </div>
              )
            ) : (
              <div className='flex justify-center w-full text-center'>
                <div className='flex mt-4'>
                  <CircularProgress size={26} />
                  <div className='px-5 pt-0.5  text-base text-gray-600'>{t('loading')}</div>
                </div>
              </div>
            )}
          </div>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  textLoading: {
    fontSize: '18px',
    textAlign: 'center',
    marginTop: '20px',
    padding: 8 * 3,
  },
  vitalSignsChart: {
    width: '100%',
    paddingTop: '5px',
    maxHeight: '500px',
    // overflowY: "scroll",
  },
  noDataBox: {
    padding: 8 * 3,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: theme.palette.text.header,
  },
  title: {
    paddingLeft: 30,
    paddingTop: 15,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: theme.palette.text.header,
  },
  gridMessage: {
    display: 'flex',
    justifyContent: 'right',
    paddingLeft: 5,
    paddingTop: 20,
    paddingRight: 12,
  },
  titleMessage: {
    marginRight: 5,
    fontSize: 12,
    fontFamily: 'kanit',
    fontWeight: 900,
  },
  captionMessages: {
    fontFamily: 'kanit',
  },
});

export const page = inject('vitalsign')(observer(VitalsignDetails));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
